import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.66796 5.89055C2.27743 5.50003 1.64427 5.50003 1.25374 5.89055C0.863215 6.28108 0.863216 6.91424 1.25374 7.30476L5.17264 11.2236C5.2635 11.3145 5.36749 11.3842 5.4785 11.4328C5.84478 11.5934 6.28767 11.5238 6.58752 11.2239L13.2538 4.55767C13.6444 4.16715 13.6444 3.53399 13.2538 3.14346C12.8633 2.75294 12.2301 2.75294 11.8396 3.14346L5.88022 9.10279L2.66796 5.89055Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }